




















































import { Component, Vue, Prop } from 'vue-property-decorator';
import Pagination from '@/components/Pagination/index.vue';
import { getFavoriteList, deleteFavorite } from '@/api/favoriteFacilities';

@Component({
  name: '',
  components: {
    Pagination,
  },
})

export default class extends Vue {
  mounted() {
    this.getFavoriteList();
  }

  private bookmarkList = [];

  private loading = true;

  private getFavoriteList() {
    this.loading = true;
    getFavoriteList().then((res) => {
      this.bookmarkList = res.data;
      this.loading = false;
    });
  }

  private deleteItem(itemUid: string) {
    this.$confirm('정말 삭제하시겠습니까?', '경고', {
      confirmButtonText: '삭제',
      cancelButtonText: '취소',
      type: 'warning',
    }).then(() => {
      deleteFavorite(itemUid).then(() => {
        this.getFavoriteList();
        this.$message({
          type: 'success',
          message: '즐겨찾기에서 삭제되었습니다.',
        });
      });
    });
  }

  private getRouter(item: any) {
    if (item.category.typeUid === '1') {
      return {
        name: 'ReservationForm',
        params: {
          menuUid: '3c28e368-21bf-437a-b51a-77a42fc9fbc3',
          categoryUid: item.categoryUid,
        },
        query: {
          itemUid: item.uid,
        },
      };
    }
    return {
      name: 'ParkingReservationForm',
      params: {
        menuUid: 'f2b16df3-6f33-48a2-bf13-44a6f43e9823',
        categoryUid: item.categoryUid,
      },
      query: {
        itemUid: item.uid,
      },
    };
  }
}
